import React from "react";
import { ethers } from "ethers";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const labelStyle = {
  marginTop: "20px",
};

const closeButtonStyle = {
  position: "absolute",
  right: "10px",
  top: "10px",
};

const fieldStyle = {
  height: "30px",
  border: "1",
  width: "100%",
};

const buttonStyle = {
  width: "100%",
  padding: "15px",
  marginTop: "40px",
};

export default function ProfileDetailsModal({
  isOpen,
  userDetails,
  onCloseHandler,
  onSubmitHandler,
}) {
  const [details, setDetails] = React.useState(userDetails);
  const [addressInvalid, setAddressInvalid] = React.useState(false);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);

  // TODO For now, only wallet address is editable
  const handleChanges = (e) => {
    let inputInvalid = false;

    if (e.target.id === "walletAddress-tf") {
      const enteredAddress = e.target.value;
      if (
        userDetails.walletAddress !== enteredAddress &&
        ethers.isAddress(enteredAddress)
      ) {
        setDetails({ ...details, walletAddress: e.target.value });
      } else {
        inputInvalid = true;
      }
    }

    setAddressInvalid(inputInvalid);
    setSubmitDisabled(inputInvalid);
  };

  const handleSubmit = () => {
    onSubmitHandler(details);
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={onCloseHandler}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 200,
          },
        }}
      >
        <Fade in={isOpen}>
          <Box sx={modalStyle}>
            <IconButton
              sx={closeButtonStyle}
              size="large"
              onClick={onCloseHandler}
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={labelStyle}>Name</Typography>
            <TextField
              sx={fieldStyle}
              disabled={true}
              defaultValue={details.name}
            />
            <Typography sx={labelStyle}>Surname</Typography>
            <TextField
              sx={fieldStyle}
              disabled={true}
              defaultValue={details.surname}
            />
            <Typography sx={labelStyle}>E-mail</Typography>
            <TextField
              sx={fieldStyle}
              disabled={true}
              defaultValue={details.email}
            ></TextField>
            <Typography sx={labelStyle}>Wallet address</Typography>
            <TextField
              error={addressInvalid}
              id="walletAddress-tf"
              sx={fieldStyle}
              defaultValue={details.walletAddress}
              helperText={addressInvalid ? "Invalid address" : ""}
              onChange={(e) => {
                handleChanges(e);
              }}
            />
            <Button
              sx={buttonStyle}
              disabled={submitDisabled}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
